module.exports = __webpack_public_path__ + "static/media/mobileScreenshot01.9bf333b4.jpg";